import { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDVMy5rk00tsOx1uWrgXosaw6s2pD6IhwQ",
  authDomain: "donata-f3d10.firebaseapp.com",
  databaseURL: "https://donata-f3d10-default-rtdb.firebaseio.com",
  projectId: "donata-f3d10",
  storageBucket: "donata-f3d10.firebasestorage.app",
  messagingSenderId: "107465588600",
  appId: "1:107465588600:web:0d6d416b8cdd7634c4d28d"
};
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

// ─── USUARIOS ────────────────────────────────────────────────────────────────
const PASS = "donata2026";
const USERS = {
  marcelo: { password: PASS, role: "editor",  display: "Marcelo" },
  hernan:  { password: PASS, role: "editor",  display: "Hernan"  },
  donata:  { password: PASS, role: "admin",   display: "Donata"  },
  jorge:   { password: PASS, role: "editor",  display: "Jorge"   },
  rosario: { password: PASS, role: "editor",  display: "Rosario" },
  pato:    { password: PASS, role: "editor",  display: "Pato"    },
  nuevo:   { password: PASS, role: "editor",  display: "Nuevo"   },
};

// ─── STOCK PANES ─────────────────────────────────────────────────────────────
const PANES = [
  "CLASICOS","BURGER","SEMILLAS","PAN QUESO",
  "CIABATTA QUESO","CIABATTA","PIZZAS","MIGA",
  "AMERICANOS","LIVIANITOS"
];
const DIAS = ["LUN","MAR","MIE","JUE","VIE","SAB","DOM"];
const DEFAULT_STOCK_PANES = PANES.map(pan => ({ pan, depo: 0, local: 0, minimo: 5 }));
const WA_GROUP = "https://chat.whatsapp.com/CfhSl4vqb6j8b9e5QFfc5v";

// ─── STOCK GENERAL — CATEGORÍAS DEL EXCEL ────────────────────────────────────
const STOCK_GENERAL = {
  tapas: {
    label: "🥐 Tapas y Rellenos",
    color: "#f59e0b",
    items: [
      // Tapas tarta
      "Tapas tarta","Tartas pollo","Tartas cebolla","Tartas verdura","Tarta carne",
      // Empanadas
      "J y Q","Carne","Tapas empanadas","Relleno carne",
      // Salsas
      "Salsa de pizza","Salsa tubo","Bolognesa","Salsa blanca",
      // Quesos y fiambres
      "Muzza tubo","Cheddar barra","Queso barra","Queso sardo","Queso azul",
      "Tybo empanadas","Paleta","Panceta","Cheddar pote","Crema de leche",
      "Jamon especial","Ricota","Parmesano","Manteca","Provolone",
      // Pastas
      "Canelones calabaza","Canelones pollo","Canelones verdura",
      "Lasagna","Guiso lentejas","Pastel de papas"
    ]
  },
  panes: {
    label: "🍞 Panes y Sandwiches",
    color: "#f5c518",
    items: [
      // Panes
      "Clasicos","Burgers","Pan queso","Pizzas","Pan de miga","Americanos",
      "Ciabatta queso","Clasicos c/semillas","Livianitos","Ciabatta",
      // Sandwiches
      "Clasicos pollo","Completo pollo","Clasico bondiola","Comp bondiola",
      "Campestres","Roast beef","Livianitos sandwich","Vacipan","Peceto",
      // Aderezos
      "Hamburguesa","Lactonesa","Barbacoa","Mayonesa","Ketchup",
      "Mostaza","Sobre mayo","Sobre ketchup","Crema"
    ]
  },
  generales: {
    label: "🧂 Generales y Condimentos",
    color: "#60a5fa",
    items: [
      // Generales
      "Aceite","Grasa","Aceite oliva","Vinagre","Salsa inglesa","Salsa de soja",
      "Vino blanco","Pan rallado","Panko","Atun","Aceitunas N","Aceitunas V",
      "Leche","Salsa tomate","Lata tomates","Calditos en cubo",
      "Azucar negra","Azucar","Arvejas","Choclos","Aji triturado",
      "Lentejas","Arroz","Maicena","Humo negro","Yerba","Tapas de lasagna",
      // Condimentos
      "Pimenton","Oregano","Pimienta","Sal fina","Sal gruesa",
      "Aji molido","Tomillo","Cebolla en polvo","Ajo en polvo",
      "Curry suave","Sesamo"
    ]
  },
  carnes: {
    label: "🥩 Carnes y Congelados",
    color: "#f87171",
    items: [
      // Carnes
      "Pechuguin crudo F","Pechuguin cocido","Pechuga crudo","Bondiola crudo",
      "Picada pollo","Tocino","Matambre","Pollos enteros","Pata muslo",
      // Lomos
      "Lomitos pollo","Lomitos carne","Lomitos 200gr",
      // Hamburguesas
      "Simples","Dobles","Pollo","Veggies","Crispy B",
      // Milanesas
      "Milanesas carne","Milanesas pollo","Mila crispy",
      // Verduras cocinadas
      "Cebolla caramel","Veggies","Mix verduras","Pepinillos",
      // Verduras
      "Papas","Cebollas","Morrones","Verdeo","Huevos","Tomates",
      "Lechuga","Rucula","Zanahoria","Cherrys","Zapallito verde",
      // Congelados
      "Papas congeladas","Aros cebolla","Baton muzzarella"
    ]
  }
};

function emptyStockGeneral() {
  const s = {};
  Object.keys(STOCK_GENERAL).forEach(cat => {
    s[cat] = {};
    STOCK_GENERAL[cat].items.forEach(item => {
      s[cat][item] = { depo: "", local: "", produccion: "" };
    });
  });
  return s;
}

function todayISO() { return new Date().toISOString().split("T")[0]; }
function weekLabel(off = 0) {
  const d = new Date();
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7) - off * 7);
  const e = new Date(d); e.setDate(d.getDate() + 6);
  const f = x => x.toLocaleDateString("es-AR", { day: "numeric", month: "short" });
  return `${f(d)} - ${f(e)}`;
}
function emptyWeek() {
  const w = {};
  PANES.forEach(p => { w[p] = {}; DIAS.forEach(d => { w[p][d] = { pedido: "", entregado: "" }; }); });
  return w;
}
function weekTotal(week, pan) {
  return DIAS.reduce((a, d) => a + (Number(week?.[pan]?.[d]?.entregado) || 0), 0);
}
async function loadH2C() {
  if (window.html2canvas) return window.html2canvas;
  return new Promise((res, rej) => {
    const s = document.createElement("script");
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
    s.onload = () => res(window.html2canvas); s.onerror = rej;
    document.head.appendChild(s);
  });
}

// ─── LOGIN ───────────────────────────────────────────────────────────────────
function LoginScreen({ onLogin, onPublic }) {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [err,  setErr]  = useState("");
  const [show, setShow] = useState(false);

  const handleLogin = () => {
    const key = user.trim().toLowerCase();
    const u = USERS[key];
    if (!u) { setErr("Usuario no encontrado"); return; }
    if (u.password !== pass) { setErr("Contraseña incorrecta"); return; }
    onLogin(key, u);
  };

  return (
    <div style={{ minHeight:"100vh", background:"#0f0f0f", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24, fontFamily:"'Bebas Neue',sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow:wght@400;600;700&display=swap'); *{box-sizing:border-box;margin:0;padding:0} input::placeholder{color:#333} input{outline:none}`}</style>
      <div style={{ marginBottom:40, textAlign:"center" }}>
        <div style={{ fontSize:"4rem", letterSpacing:8, color:"#f5c518", lineHeight:1 }}>DONATA</div>
        <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".8rem", color:"#444", letterSpacing:4, marginTop:4 }}>GESTION DE STOCK</div>
      </div>
      <div style={{ background:"#141414", border:"1px solid #2a2a2a", borderRadius:14, padding:"32px 28px", width:"100%", maxWidth:360 }}>
        <div style={{ fontSize:"1.2rem", letterSpacing:3, color:"#888", marginBottom:24, textAlign:"center" }}>INICIAR SESION</div>
        <div style={{ marginBottom:14 }}>
          <label style={{ fontFamily:"'Barlow',sans-serif", fontSize:".72rem", color:"#555", letterSpacing:2, display:"block", marginBottom:6 }}>USUARIO</label>
          <input value={user} onChange={e => { setUser(e.target.value); setErr(""); }}
            onKeyDown={e => e.key==="Enter" && handleLogin()}
            placeholder="Tu nombre de usuario"
            style={{ width:"100%", background:"#1e1e1e", border:"1px solid #333", borderRadius:8, padding:"12px 14px", color:"#fff", fontFamily:"'Barlow',sans-serif", fontSize:".95rem" }} />
        </div>
        <div style={{ marginBottom:20 }}>
          <label style={{ fontFamily:"'Barlow',sans-serif", fontSize:".72rem", color:"#555", letterSpacing:2, display:"block", marginBottom:6 }}>CONTRASEÑA</label>
          <div style={{ position:"relative" }}>
            <input type={show?"text":"password"} value={pass} onChange={e => { setPass(e.target.value); setErr(""); }}
              onKeyDown={e => e.key==="Enter" && handleLogin()}
              placeholder="••••••••"
              style={{ width:"100%", background:"#1e1e1e", border:"1px solid #333", borderRadius:8, padding:"12px 44px 12px 14px", color:"#fff", fontFamily:"'Barlow',sans-serif", fontSize:".95rem" }} />
            <button onClick={() => setShow(!show)} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:"#555", cursor:"pointer", fontSize:"1rem" }}>
              {show ? "🙈" : "👁"}
            </button>
          </div>
        </div>
        {err && <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".82rem", color:"#f87171", marginBottom:14, textAlign:"center" }}>⚠ {err}</div>}
        <button onClick={handleLogin} style={{ width:"100%", background:"#f5c518", color:"#111", border:"none", borderRadius:8, padding:"13px", fontFamily:"'Bebas Neue',sans-serif", fontSize:"1.2rem", letterSpacing:3, cursor:"pointer", marginBottom:12 }}>
          ENTRAR
        </button>
        <button onClick={onPublic} style={{ width:"100%", background:"none", color:"#444", border:"1px solid #222", borderRadius:8, padding:"11px", fontFamily:"'Barlow',sans-serif", fontSize:".82rem", cursor:"pointer" }}>
          Ver como invitado (solo lectura)
        </button>
      </div>
      <div style={{ marginTop:24, fontFamily:"'Barlow',sans-serif", fontSize:".72rem", color:"#2a2a2a" }}>DONATA © {new Date().getFullYear()}</div>
    </div>
  );
}

// ─── MENU PRINCIPAL ───────────────────────────────────────────────────────────
function MenuPrincipal({ userInfo, onSelect, onLogout }) {
  const C = { bg:"#0f0f0f", card:"#141414", border:"#2a2a2a", acc:"#f5c518", txt:"#e0e0e0", muted:"#555" };
  const opciones = [
    { id:"panes",    icon:"🍞", titulo:"Stock de Panes",     desc:"Stock diario, semanal y resumen de panes",    color:"#f5c518" },
    { id:"general",  icon:"📦", titulo:"Stock General",       desc:"Tapas, carnes, generales y más categorías",   color:"#60a5fa" },
  ];
  return (
    <div style={{ minHeight:"100vh", background:C.bg, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24, fontFamily:"'Bebas Neue',sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow:wght@400;600;700&display=swap'); *{box-sizing:border-box;margin:0;padding:0}`}</style>
      <div style={{ marginBottom:32, textAlign:"center" }}>
        <div style={{ fontSize:"3rem", letterSpacing:8, color:C.acc, lineHeight:1 }}>DONATA</div>
        <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".78rem", color:C.muted, letterSpacing:4, marginTop:4 }}>GESTION DE STOCK</div>
        <div style={{ marginTop:12, fontFamily:"'Barlow',sans-serif", fontSize:".88rem", color:C.acc, fontWeight:700 }}>
          Hola, {userInfo.display} 👋
        </div>
      </div>
      <div style={{ width:"100%", maxWidth:400, display:"flex", flexDirection:"column", gap:12 }}>
        <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".72rem", color:C.muted, letterSpacing:3, marginBottom:4 }}>¿QUÉ QUERÉS HACER HOY?</div>
        {opciones.map(op => (
          <button key={op.id} onClick={() => onSelect(op.id)}
            style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:14, padding:"20px 20px", display:"flex", alignItems:"center", gap:16, cursor:"pointer", textAlign:"left", transition:"all .2s", width:"100%" }}
            onMouseEnter={e => e.currentTarget.style.borderColor = op.color}
            onMouseLeave={e => e.currentTarget.style.borderColor = C.border}>
            <div style={{ fontSize:"2.2rem" }}>{op.icon}</div>
            <div>
              <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:"1.2rem", letterSpacing:2, color:op.color }}>{op.titulo}</div>
              <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".78rem", color:C.muted, marginTop:3 }}>{op.desc}</div>
            </div>
            <div style={{ marginLeft:"auto", color:C.muted, fontSize:"1.2rem" }}>›</div>
          </button>
        ))}
      </div>
      <button onClick={onLogout} style={{ marginTop:32, background:"none", border:"none", color:C.muted, fontFamily:"'Barlow',sans-serif", fontSize:".8rem", cursor:"pointer", textDecoration:"underline" }}>
        Cerrar sesión
      </button>
    </div>
  );
}

// ─── STOCK GENERAL ────────────────────────────────────────────────────────────
function StockGeneral({ userInfo, onBack, stockGen, setStockGen, persist, syncing }) {
  const canEdit = true;
  const [catActiva, setCatActiva] = useState("tapas");
  const [editCell, setEditCell] = useState(null);
  const [editVal, setEditVal] = useState("");
  const [addingItem, setAddingItem] = useState(null);
  const [newItem, setNewItem] = useState("");
  const [fecha, setFecha] = useState(todayISO());
  const [updated, setUpdated] = useState(null);

  const C = { bg:"#0f0f0f", hd:"#141414", card:"#141414", card2:"#111", border:"#222", acc:"#f5c518", txt:"#e0e0e0", muted:"#555", dim:"#333" };

  const cat = STOCK_GENERAL[catActiva];
  const extraItems = Object.keys(stockGen?.[catActiva] || {}).filter(i => !cat.items.includes(i));
  const allItems = [...cat.items, ...extraItems];

  const startEdit = (key, val) => { setEditCell(key); setEditVal(String(val ?? "")); };

  const commitEdit = (catId, item, field) => {
    const newStock = JSON.parse(JSON.stringify(stockGen || emptyStockGeneral()));
    if (!newStock[catId]) newStock[catId] = {};
    if (!newStock[catId][item]) newStock[catId][item] = { depo:"", local:"", produccion:"" };
    newStock[catId][item][field] = editVal;
    const now = new Date().toISOString();
    setUpdated(now);
    persist({ stockGeneral: newStock, stockGeneralUpdated: now });
    setStockGen(newStock);
    setEditCell(null);
  };

  const addItem = () => {
    if (!newItem.trim()) return;
    const newStock = JSON.parse(JSON.stringify(stockGen || emptyStockGeneral()));
    if (!newStock[addingItem]) newStock[addingItem] = {};
    newStock[addingItem][newItem.trim()] = { depo:"", local:"", produccion:"" };
    persist({ stockGeneral: newStock });
    setStockGen(newStock);
    setAddingItem(null);
    setNewItem("");
  };

  const removeItem = (catId, item) => {
    if (!window.confirm(`¿Eliminar "${item}"?`)) return;
    const newStock = JSON.parse(JSON.stringify(stockGen || emptyStockGeneral()));
    if (newStock[catId]) delete newStock[catId][item];
    persist({ stockGeneral: newStock });
    setStockGen(newStock);
  };

  const shareWA = () => {
    const lines = [`📦 *DONATA - STOCK GENERAL*`, `📅 ${new Date(fecha+"T12:00:00").toLocaleDateString("es-AR",{weekday:"long",day:"numeric",month:"long"})}`, ``];
    Object.entries(STOCK_GENERAL).forEach(([catId, catData]) => {
      const items = allItems;
      const hasData = cat.items.some(item => {
        const v = stockGen?.[catId]?.[item];
        return v && (v.depo || v.local || v.produccion);
      });
      if (!hasData) return;
      lines.push(`*${catData.label.toUpperCase()}*`);
      catData.items.forEach(item => {
        const v = stockGen?.[catId]?.[item];
        if (!v || (!v.depo && !v.local && !v.produccion)) return;
        const parts = [];
        if (v.depo) parts.push(`Dep: ${v.depo}`);
        if (v.local) parts.push(`Loc: ${v.local}`);
        if (v.produccion) parts.push(`Prod: ${v.produccion}`);
        lines.push(`▪ ${item}: ${parts.join(" | ")}`);
      });
      lines.push("");
    });
    lines.push(`_${userInfo.display} · ${new Date().toLocaleTimeString("es-AR",{hour:"2-digit",minute:"2-digit"})}_`);
    window.open(`https://wa.me/?text=${encodeURIComponent(lines.join("\n"))}`,"_blank");
  };

  const th = (align="center", minW=80) => ({
    padding:"9px 8px", color:C.acc, fontFamily:"'Bebas Neue',sans-serif",
    fontSize:".8rem", letterSpacing:2, textAlign:align, fontWeight:"normal",
    borderBottom:`2px solid ${C.acc}`, minWidth:minW, whiteSpace:"nowrap"
  });

  return (
    <div style={{ minHeight:"100vh", background:C.bg, fontFamily:"'Bebas Neue',sans-serif", color:C.txt, paddingBottom:80 }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow:wght@400;500;600;700&display=swap'); *{box-sizing:border-box;margin:0;padding:0} .ei2{background:#f5c518;color:#111;border:none;width:70px;font-size:.9rem;font-family:'Barlow',sans-serif;font-weight:700;text-align:center;border-radius:4px;padding:3px} .ei2:focus{outline:2px solid #fff} .rh2:hover{background:rgba(255,255,255,.02)!important} input{outline:none} input::placeholder{color:#333}`}</style>

      {/* HEADER */}
      <div style={{ background:C.hd, borderBottom:`3px solid ${cat.color}`, padding:"12px 16px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:8 }}>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <button onClick={onBack} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:"1.4rem", lineHeight:1 }}>←</button>
          <div>
            <div style={{ fontSize:"1.8rem", letterSpacing:4, color:cat.color, lineHeight:1 }}>STOCK GENERAL</div>
            <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".7rem", color:C.muted, marginTop:2 }}>{userInfo.display} · {syncing?"sincronizando...":"✓ guardado"}</div>
          </div>
        </div>
        <input type="date" value={fecha} onChange={e=>setFecha(e.target.value)}
          style={{ background:"none", border:"none", color:C.muted, fontFamily:"'Barlow',sans-serif", fontSize:".75rem", cursor:"pointer" }} />
      </div>

      {/* TABS CATEGORÍAS */}
      <div style={{ background:C.hd, borderBottom:`1px solid ${C.border}`, display:"flex", overflowX:"auto", padding:"6px 8px", gap:6 }}>
        {Object.entries(STOCK_GENERAL).map(([id, c]) => (
          <button key={id} onClick={() => setCatActiva(id)}
            style={{ background:catActiva===id?c.color:"none", border:`1px solid ${catActiva===id?c.color:C.border}`, borderRadius:20, padding:"6px 14px", color:catActiva===id?"#111":C.muted, fontFamily:"'Barlow',sans-serif", fontSize:".75rem", fontWeight:600, cursor:"pointer", whiteSpace:"nowrap", transition:"all .2s" }}>
            {c.label}
          </button>
        ))}
      </div>

      {/* TABLA */}
      <div style={{ maxWidth:700, margin:"0 auto", padding:"12px 8px" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"0 4px", marginBottom:12 }}>
          <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".8rem", color:cat.color, fontWeight:700 }}>{cat.label}</div>
          <button onClick={() => setAddingItem(catActiva)}
            style={{ background:"none", border:`1px dashed ${C.border}`, borderRadius:6, padding:"4px 12px", color:C.muted, fontFamily:"'Barlow',sans-serif", fontSize:".72rem", cursor:"pointer" }}>
            + agregar producto
          </button>
        </div>

        {addingItem === catActiva && (
          <div style={{ display:"flex", gap:8, marginBottom:12, padding:"10px 12px", background:C.card2, borderRadius:8 }}>
            <input autoFocus value={newItem} onChange={e=>setNewItem(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&addItem()}
              placeholder="Nombre del producto..."
              style={{ flex:1, background:C.bg, border:`1px solid ${C.border}`, borderRadius:6, padding:"8px 12px", color:C.txt, fontFamily:"'Barlow',sans-serif", fontSize:".88rem" }} />
            <button onClick={addItem} style={{ background:C.acc, color:"#111", border:"none", borderRadius:6, padding:"8px 14px", fontFamily:"'Barlow',sans-serif", fontSize:".82rem", fontWeight:700, cursor:"pointer" }}>Agregar</button>
            <button onClick={() => { setAddingItem(null); setNewItem(""); }} style={{ background:"none", border:`1px solid ${C.border}`, borderRadius:6, padding:"8px 12px", color:C.muted, fontFamily:"'Barlow',sans-serif", fontSize:".82rem", cursor:"pointer" }}>✕</button>
          </div>
        )}

        <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ background:"#1a1a1a" }}>
                <th style={th("left", 160)}>PRODUCTO</th>
                <th style={th("center", 80)}>DEPÓSITO</th>
                <th style={{ ...th("center", 80), color:"#60a5fa" }}>LOCAL</th>
                <th style={{ ...th("center", 80), color:"#a78bfa" }}>PRODUCCIÓN</th>
                <th style={th("center", 30)}></th>
              </tr>
            </thead>
            <tbody>
              {allItems.map((item, i) => {
                const v = stockGen?.[catActiva]?.[item] || { depo:"", local:"", produccion:"" };
                const isExtra = !cat.items.includes(item);
                return (
                  <tr key={item} className="rh2" style={{ background: i%2===0?"#141414":"#111", borderBottom:`1px solid #1e1e1e` }}>
                    <td style={{ padding:"10px 12px", fontFamily:"'Barlow',sans-serif", fontWeight:500, fontSize:".88rem", color: isExtra ? "#aaa" : C.txt, display:"flex", alignItems:"center", gap:6 }}>
                      {isExtra && <span style={{ fontSize:".6rem", color:"#555", background:"#1e1e1e", padding:"1px 5px", borderRadius:3 }}>+</span>}
                      {item}
                    </td>
                    {["depo","local","produccion"].map(field => {
                      const key = `${catActiva}-${item}-${field}`;
                      const val = v[field] ?? "";
                      const colColor = field==="local"?"#60a5fa":field==="produccion"?"#a78bfa":C.txt;
                      return (
                        <td key={field} style={{ textAlign:"center", padding:"8px 4px" }} onDoubleClick={() => startEdit(key, val)}>
                          {editCell===key ? (
                            <input className="ei2" autoFocus value={editVal}
                              onChange={e=>setEditVal(e.target.value)}
                              onBlur={() => commitEdit(catActiva, item, field)}
                              onKeyDown={e=>e.key==="Enter"&&commitEdit(catActiva, item, field)} />
                          ) : (
                            <span style={{ cursor:"pointer", fontFamily:"'Barlow',sans-serif", fontWeight:500, fontSize:".9rem", color: val ? colColor : "#2a2a2a" }}>
                              {val || "—"}
                            </span>
                          )}
                        </td>
                      );
                    })}
                    <td style={{ textAlign:"center", padding:"8px 4px" }}>
                      {isExtra && (
                        <button onClick={() => removeItem(catActiva, item)}
                          style={{ background:"none", border:"none", color:"#555", cursor:"pointer", fontSize:".8rem" }}>✕</button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <p style={{ textAlign:"center", fontFamily:"'Barlow',sans-serif", fontSize:".7rem", color:C.dim, padding:"10px 0" }}>Doble click para editar · Podés agregar y quitar productos</p>
      </div>

      {/* BOTTOM */}
      <div style={{ position:"fixed", bottom:0, left:0, right:0, background:C.hd, borderTop:`1px solid ${C.border}`, padding:"10px 16px", display:"flex", gap:8, justifyContent:"center" }}>
        <button onClick={shareWA}
          style={{ flex:1, maxWidth:200, background:"#0d3d1a", border:"1px solid #1a5a28", borderRadius:8, padding:"11px", color:"#4ade80", fontFamily:"'Bebas Neue',sans-serif", fontSize:".88rem", letterSpacing:2, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
          💬 WHATSAPP
        </button>
        <button onClick={() => window.print()}
          style={{ flex:1, maxWidth:160, background:"#0d1a3a", border:"1px solid #1a3a5a", borderRadius:8, padding:"11px", color:"#60a5fa", fontFamily:"'Bebas Neue',sans-serif", fontSize:".88rem", letterSpacing:2, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
          🖨️ IMPRIMIR
        </button>
      </div>
    </div>
  );
}

// ─── MAIN ────────────────────────────────────────────────────────────────────
export default function Donata() {
  const [user,       setUser]       = useState(null);
  const [userInfo,   setUserInfo]   = useState(null);
  const [isPublic,   setIsPublic]   = useState(false);
  const [seccion,    setSeccion]    = useState(null); // null=menu, "panes", "general"
  const [tab,        setTab]        = useState("stock");
  const [stock,      setStock]      = useState(DEFAULT_STOCK_PANES);
  const [stockGen,   setStockGen]   = useState(emptyStockGeneral());
  const [stockFecha, setStockFecha] = useState(todayISO());
  const [stockUpdated, setStockUpdated] = useState(null);
  const [weeks,      setWeeks]      = useState([emptyWeek(),emptyWeek(),emptyWeek(),emptyWeek()]);
  const [weekIdx,    setWeekIdx]    = useState(0);
  const [editCell,   setEditCell]   = useState(null);
  const [editVal,    setEditVal]    = useState("");
  const [aiLoading,  setAiLoading]  = useState(false);
  const [aiMsg,      setAiMsg]      = useState("");
  const [syncing,    setSyncing]    = useState(false);
  const fileRef  = useRef();
  const stockRef = useRef();

  const canEdit = userInfo?.role === "editor" || userInfo?.role === "admin";
  const isAdmin = userInfo?.role === "admin";

  useEffect(() => {
    const dbRef = ref(db, "donata");
    const unsub = onValue(dbRef, snap => {
      const data = snap.val();
      if (data) {
        if (data.stock)         setStock(data.stock);
        if (data.stockFecha)    setStockFecha(data.stockFecha);
        if (data.stockUpdated)  setStockUpdated(data.stockUpdated);
        if (data.weeks)         setWeeks(data.weeks);
        if (data.stockGeneral)  setStockGen(data.stockGeneral);
      }
    });
    return () => unsub();
  }, []);

  const persist = (patch) => {
    const current = { stock, stockFecha, stockUpdated, weeks, stockGeneral: stockGen };
    const next = { ...current, ...patch };
    setSyncing(true);
    set(ref(db, "donata"), next).finally(() => setSyncing(false));
    if (patch.stock        !== undefined) setStock(patch.stock);
    if (patch.stockFecha   !== undefined) setStockFecha(patch.stockFecha);
    if (patch.stockUpdated !== undefined) setStockUpdated(patch.stockUpdated);
    if (patch.weeks        !== undefined) setWeeks(patch.weeks);
    if (patch.stockGeneral !== undefined) setStockGen(patch.stockGeneral);
  };

  const startEdit = (key, val) => {
    if (!canEdit) return;
    setEditCell(key); setEditVal(String(val ?? ""));
  };
  const commitStock = (i, field) => {
    const updated = stock.map((p, idx) => idx === i ? { ...p, [field]: Number(editVal) || 0 } : p);
    persist({ stock: updated, stockUpdated: new Date().toISOString() });
    setEditCell(null);
  };
  const commitWeek = (pan, dia, tipo) => {
    const updated = weeks.map((w, wi) => {
      if (wi !== weekIdx) return w;
      return { ...w, [pan]: { ...w[pan], [dia]: { ...w[pan][dia], [tipo]: editVal === "" ? "" : Number(editVal) || 0 } } };
    });
    persist({ weeks: updated });
    setEditCell(null);
  };

  const handleFoto = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setAiLoading(true); setAiMsg("");
    try {
      const base64 = await new Promise((res, rej) => {
        const r = new FileReader();
        r.onload = () => res(r.result.split(",")[1]);
        r.onerror = rej;
        r.readAsDataURL(file);
      });
      const resp = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-20250514", max_tokens: 1000,
          messages: [{ role: "user", content: [
            { type: "image", source: { type: "base64", media_type: file.type || "image/jpeg", data: base64 } },
            { type: "text", text: `Analiza planilla de stock DONATA. Extrae PAN, DEPO, LOCAL (guion=0, 1K=1000). Solo JSON sin markdown: [{"pan":"CLASICOS","depo":50,"local":0},...]` }
          ]}]
        })
      });
      const data = await resp.json();
      const text = data.content?.map(b => b.text || "").join("") ?? "";
      const parsed = JSON.parse(text.replace(/```json|```/g,"").trim());
      const updated = stock.map(p => {
        const f = parsed.find(r => r.pan?.toUpperCase().replace(/[^A-Z0-9 ]/g,"").trim() === p.pan.replace(/[^A-Z0-9 ]/g,""));
        return f ? { ...p, depo: Number(f.depo), local: Number(f.local) } : p;
      });
      persist({ stock: updated, stockUpdated: new Date().toISOString() });
      setAiMsg("ok Stock actualizado desde la foto");
      setTab("stock");
    } catch { setAiMsg("err No se pudo leer. Intenta de nuevo."); }
    finally { setAiLoading(false); e.target.value = ""; }
  };

  const shareWhatsApp = () => {
    const fecha = new Date(stockFecha + "T12:00:00").toLocaleDateString("es-AR", { weekday:"long", day:"numeric", month:"long" });
    const alertas = stock.filter(p => (p.depo + p.local) < (p.minimo ?? 5));
    const lines = stock.map(p => {
      const total = p.depo + p.local;
      const bajo = total < (p.minimo ?? 5);
      const local = p.local > 0 ? ` (local: ${p.local})` : "";
      return `${bajo?"🔴":"▪"} ${p.pan}: *${total}*${local}${bajo?" ⚠":""}`;
    });
    const msg = [`🍞 *DONATA - STOCK DEL DIA*`,`📅 ${fecha}`,``,...lines,``,
      alertas.length?`⚠ *Stock bajo:* ${alertas.map(p=>p.pan).join(", ")}`:`✅ Todo el stock en orden`,``,
      `_Cargado por: ${userInfo?.display??"Sistema"} - ${stockUpdated?new Date(stockUpdated).toLocaleTimeString("es-AR",{hour:"2-digit",minute:"2-digit"}):"--"}_`
    ].join("\n");
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank");
  };

  const captureImagen = async () => {
    if (!stockRef.current) return;
    try {
      const h2c = await loadH2C();
      const canvas = await h2c(stockRef.current, { backgroundColor:"#0f0f0f", scale:2, useCORS:true, logging:false });
      const link = document.createElement("a");
      link.download = `donata_stock_${todayISO()}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch { alert("No se pudo generar la imagen."); }
  };

  const downloadXLSX = () => {
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(
      stock.map(p => ({ PAN:p.pan, DEPO:p.depo, LOCAL:p.local, TOTAL:p.depo+p.local, MINIMO:p.minimo??5 }))
    ), "Stock Panes");
    weeks.forEach((w,wi) => {
      const rows = [];
      PANES.forEach(pan => {
        rows.push({ TIPO:"PEDIDO", PAN:pan, ...Object.fromEntries(DIAS.map(d=>[d,w[pan]?.[d]?.pedido??""])) });
        rows.push({ TIPO:"ENTREGADO", PAN:pan, ...Object.fromEntries(DIAS.map(d=>[d,w[pan]?.[d]?.entregado??""])), TOTAL:weekTotal(w,pan) });
      });
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), `Semana ${wi+1}`);
    });
    Object.entries(STOCK_GENERAL).forEach(([catId, catData]) => {
      const rows = catData.items.map(item => {
        const v = stockGen?.[catId]?.[item] || {};
        return { PRODUCTO:item, DEPOSITO:v.depo||"", LOCAL:v.local||"", PRODUCCION:v.produccion||"" };
      });
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), catData.label.replace(/[^a-zA-Z0-9 ]/g,"").trim().slice(0,31));
    });
    XLSX.writeFile(wb, `donata_${todayISO()}.xlsx`);
  };

  const promedios = PANES.map(pan => {
    const totals = weeks.map(w=>weekTotal(w,pan));
    const nz = totals.filter(t=>t>0);
    return { pan, totals, avg:nz.length?Math.round(totals.reduce((a,b)=>a+b,0)/nz.length):0 };
  });

  const alertasPanes = stock.filter(p=>(p.depo+p.local)<(p.minimo??5));
  const fechaDisplay = new Date(stockFecha+"T12:00:00").toLocaleDateString("es-AR",{weekday:"long",day:"numeric",month:"long",year:"numeric"});

  const C = { bg:"#0f0f0f", hd:"#141414", acc:"#f5c518", b1:"#141414", b2:"#111111", border:"#222", txt:"#e0e0e0", muted:"#555", dim:"#333" };
  const th = (align="center",minW=60) => ({ padding:"9px 8px", color:C.acc, fontFamily:"'Bebas Neue',sans-serif", fontSize:".85rem", letterSpacing:2, textAlign:align, fontWeight:"normal", borderBottom:`2px solid ${C.acc}`, minWidth:minW, whiteSpace:"nowrap" });

  // ── PANTALLA LOGIN ──
  if (!user && !isPublic) {
    return <LoginScreen onLogin={(k,info)=>{setUser(k);setUserInfo(info);}} onPublic={()=>setIsPublic(true)} />;
  }

  // ── MENÚ PRINCIPAL (solo usuarios logueados, no invitados) ──
  if (user && !seccion) {
    return <MenuPrincipal userInfo={userInfo} onSelect={setSeccion} onLogout={()=>{setUser(null);setUserInfo(null);setSeccion(null);}} />;
  }

  // ── STOCK GENERAL ──
  if (seccion === "general") {
    return <StockGeneral
      userInfo={userInfo}
      onBack={() => setSeccion(null)}
      stockGen={stockGen}
      setStockGen={setStockGen}
      persist={persist}
      syncing={syncing}
    />;
  }

  // ── STOCK PANES (seccion === "panes" o invitado) ──
  return (
    <div style={{ minHeight:"100vh", background:C.bg, fontFamily:"'Bebas Neue','Arial Black',sans-serif", color:C.txt, paddingBottom:80 }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow:wght@400;500;600;700&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .ei{background:#f5c518;color:#111;border:none;width:52px;font-size:.95rem;font-family:'Barlow',sans-serif;font-weight:700;text-align:center;border-radius:4px;padding:2px}
        .ei:focus{outline:2px solid #fff}
        .rh:hover{background:rgba(245,197,24,.03)!important}
        .tab{background:none;border:none;color:#555;font-family:'Bebas Neue',sans-serif;font-size:1rem;letter-spacing:2px;padding:10px 12px;cursor:pointer;border-bottom:3px solid transparent;transition:all .2s;white-space:nowrap}
        .tab.on{color:#f5c518;border-bottom-color:#f5c518}
        .tab:hover{color:#bbb}
        .wbtn{background:none;border:1px solid #2a2a2a;border-radius:5px;color:#666;font-family:'Barlow',sans-serif;font-size:.72rem;padding:4px 10px;cursor:pointer;transition:all .2s}
        .wbtn.on{background:#f5c518;color:#111;border-color:#f5c518;font-weight:700}
        .wbtn:hover{border-color:#f5c518;color:#f5c518}
        ::-webkit-scrollbar{height:4px;width:4px}::-webkit-scrollbar-track{background:#1a1a1a}::-webkit-scrollbar-thumb{background:#333;border-radius:2px}
        @media print{.np{display:none!important}}
        input::placeholder{color:#444} input{outline:none}
      `}</style>

      {/* HEADER */}
      <div style={{ background:C.hd, borderBottom:`3px solid ${C.acc}`, padding:"12px 16px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:8 }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          {user && <button onClick={()=>setSeccion(null)} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:"1.3rem" }}>←</button>}
          <div style={{ fontSize:"2.4rem", letterSpacing:4, color:C.acc, lineHeight:1 }}>DONATA</div>
          {syncing && <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".65rem", color:"#f5c518", background:"rgba(245,197,24,.1)", padding:"3px 8px", borderRadius:4 }}>⟳ sync</div>}
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          {alertasPanes.length > 0 && (
            <div style={{ background:"#3a0d0d", border:"1px solid #7a2020", borderRadius:6, padding:"4px 10px", fontFamily:"'Barlow',sans-serif", fontSize:".72rem", color:"#f87171", fontWeight:600 }}>
              ⚠ {alertasPanes.length} bajo minimo
            </div>
          )}
          <div style={{ textAlign:"right" }}>
            <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".72rem", color:isPublic?"#555":isAdmin?"#f5c518":"#4ade80", fontWeight:700 }}>
              {isPublic?"INVITADO":isAdmin?"★ "+userInfo.display.toUpperCase():userInfo.display.toUpperCase()}
            </div>
            <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".62rem", color:"#333" }}>{isPublic?"solo lectura":isAdmin?"administrador":"editor"}</div>
          </div>
          <button onClick={()=>{setUser(null);setUserInfo(null);setIsPublic(false);setSeccion(null);}}
            style={{ background:"#1e1e1e", border:"1px solid #2a2a2a", borderRadius:6, padding:"5px 10px", color:"#555", fontFamily:"'Barlow',sans-serif", fontSize:".7rem", cursor:"pointer" }}>
            Salir
          </button>
        </div>
      </div>

      {/* FECHA */}
      <div style={{ background:C.hd, borderBottom:`1px solid ${C.border}`, padding:"6px 16px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".75rem", color:"#555", textTransform:"capitalize" }}>{fechaDisplay}</div>
        {canEdit && <input type="date" value={stockFecha} onChange={e=>persist({stockFecha:e.target.value})}
          style={{ background:"none", border:"none", color:"#444", fontFamily:"'Barlow',sans-serif", fontSize:".75rem", cursor:"pointer" }} />}
      </div>

      {/* TABS */}
      <div className="np" style={{ background:C.hd, borderBottom:`1px solid ${C.border}`, display:"flex", overflowX:"auto", paddingLeft:6 }}>
        {[["stock","STOCK"],["semanal","SEMANAL"],["resumen","RESUMEN"],...(canEdit?[["foto","FOTO"]]:[])].map(([id,label])=>(
          <button key={id} className={`tab ${tab===id?"on":""}`} onClick={()=>setTab(id)}>{label}</button>
        ))}
      </div>

      {/* ULT ACT */}
      {stockUpdated && tab==="stock" && (
        <div style={{ background:"#0f0f0f", borderBottom:`1px solid #1a1a1a`, padding:"4px 16px", fontFamily:"'Barlow',sans-serif", fontSize:".7rem", color:"#2e2e2e", display:"flex", gap:6, alignItems:"center" }}>
          🕐 Ultima actualizacion:
          <span style={{ color:"#3a3a3a", fontWeight:600 }}>
            {new Date(stockUpdated).toLocaleDateString("es-AR",{day:"numeric",month:"short"})} · {new Date(stockUpdated).toLocaleTimeString("es-AR",{hour:"2-digit",minute:"2-digit"})}
          </span>
          <span style={{ marginLeft:"auto", color:"#1a5a1a", fontSize:".65rem" }}>● firebase</span>
        </div>
      )}

      {/* ═══ STOCK PANES ═══ */}
      {tab==="stock" && (
        <div style={{ maxWidth:560, margin:"0 auto" }}>
          <div ref={stockRef} style={{ background:C.bg }}>
            {aiMsg && (
              <div style={{ padding:"8px 16px", background:aiMsg.startsWith("ok")?"#0d2e0d":"#2e0d0d", color:aiMsg.startsWith("ok")?"#4ade80":"#f87171", fontFamily:"'Barlow',sans-serif", fontSize:".86rem", fontWeight:600, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                {aiMsg.startsWith("ok")?"✓":"❌"} {aiMsg.slice(3)}
                <button onClick={()=>setAiMsg("")} style={{ background:"none", border:"none", color:"inherit", cursor:"pointer" }}>x</button>
              </div>
            )}
            {alertasPanes.length>0 && (
              <div style={{ margin:"10px 12px 0", padding:"10px 14px", background:"#1e0a0a", border:"1px solid #5a1a1a", borderRadius:8 }}>
                <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:"1rem", letterSpacing:2, color:"#f87171", marginBottom:6 }}>⚠ STOCK BAJO MINIMO</div>
                <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                  {alertasPanes.map(p=>(
                    <span key={p.pan} style={{ fontFamily:"'Barlow',sans-serif", fontSize:".75rem", color:"#f87171", background:"#2e0d0d", borderRadius:4, padding:"3px 8px" }}>
                      {p.pan}: {p.depo+p.local} (min {p.minimo??5})
                    </span>
                  ))}
                </div>
              </div>
            )}
            <table style={{ width:"100%", borderCollapse:"collapse", marginTop:8 }}>
              <thead>
                <tr style={{ background:"#1a1a1a" }}>
                  {["PAN","DEPO","LOCAL","TOTAL",...(isAdmin?["MIN"]:[])] .map((h,i)=>(
                    <th key={h} style={th(i===0?"left":"center",i===0?130:70)}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {stock.map((p,i)=>{
                  const total = p.depo+p.local;
                  const bajo = total<(p.minimo??5);
                  return (
                    <tr key={p.pan} className="rh" style={{ background:bajo?"#180a0a":i%2===0?C.b1:C.b2, borderBottom:`1px solid #1e1e1e` }}>
                      <td style={{ padding:"12px 12px", fontFamily:"'Barlow',sans-serif", fontWeight:700, fontSize:".92rem", color:bajo?"#f87171":C.txt }}>
                        {bajo&&<span style={{ marginRight:5 }}>⚠</span>}{p.pan}
                      </td>
                      {["depo","local"].map(field=>(
                        <td key={field} style={{ textAlign:"center", padding:"12px 6px" }} onDoubleClick={()=>startEdit(`s${i}${field}`,p[field])}>
                          {editCell===`s${i}${field}`?(
                            <input className="ei" autoFocus value={editVal} onChange={e=>setEditVal(e.target.value)}
                              onBlur={()=>commitStock(i,field)} onKeyDown={e=>e.key==="Enter"&&commitStock(i,field)} />
                          ):(
                            <span style={{ cursor:canEdit?"pointer":"default", fontFamily:"'Barlow',sans-serif", fontWeight:600, color:field==="local"&&!p.local?C.dim:C.txt }}>
                              {field==="local"&&!p.local?"-":p[field]}
                            </span>
                          )}
                        </td>
                      ))}
                      <td style={{ textAlign:"center", color:bajo?"#f87171":C.acc, fontFamily:"'Barlow',sans-serif", fontWeight:700, fontSize:"1.05rem" }}>{total}</td>
                      {isAdmin&&(
                        <td style={{ textAlign:"center" }} onDoubleClick={()=>startEdit(`smin${i}`,p.minimo??5)}>
                          {editCell===`smin${i}`?(
                            <input className="ei" autoFocus value={editVal} onChange={e=>setEditVal(e.target.value)}
                              onBlur={()=>{const u=stock.map((s,idx)=>idx===i?{...s,minimo:Number(editVal)||5}:s);persist({stock:u});setEditCell(null);}}
                              onKeyDown={e=>{if(e.key==="Enter"){const u=stock.map((s,idx)=>idx===i?{...s,minimo:Number(editVal)||5}:s);persist({stock:u});setEditCell(null);}}} />
                          ):(
                            <span style={{ cursor:"pointer", fontFamily:"'Barlow',sans-serif", fontSize:".82rem", color:"#444" }}>{p.minimo??5}</span>
                          )}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p style={{ textAlign:"center", fontFamily:"'Barlow',sans-serif", fontSize:".68rem", color:C.dim, padding:"8px 0 4px" }}>
            {canEdit?"Doble click para editar":"Solo lectura"}
          </p>
          <div style={{ display:"flex", gap:8, padding:"8px 12px 16px" }}>
            <button onClick={shareWhatsApp} style={{ flex:1, background:"#0d3d1a", border:"1px solid #1a5a28", borderRadius:8, padding:"11px 8px", color:"#4ade80", fontFamily:"'Bebas Neue',sans-serif", fontSize:".88rem", letterSpacing:2, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:5 }}>
              💬 WHATSAPP
            </button>
            <button onClick={captureImagen} style={{ flex:1, background:"#1a2a3d", border:"1px solid #1a3a5a", borderRadius:8, padding:"11px 8px", color:"#60a5fa", fontFamily:"'Bebas Neue',sans-serif", fontSize:".88rem", letterSpacing:2, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:5 }}>
              🖼️ IMAGEN
            </button>
            <a href={WA_GROUP} target="_blank" rel="noreferrer" style={{ flex:1, background:"#1a3a1a", border:"1px solid #2a5a2a", borderRadius:8, padding:"11px 8px", color:"#86efac", fontFamily:"'Bebas Neue',sans-serif", fontSize:".88rem", letterSpacing:2, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:5, textDecoration:"none" }}>
              👥 GRUPO
            </a>
          </div>
        </div>
      )}

      {/* ═══ SEMANAL ═══ */}
      {tab==="semanal" && (
        <div style={{ padding:"12px 8px" }}>
          <div style={{ display:"flex", gap:8, marginBottom:10, flexWrap:"wrap", alignItems:"center", padding:"0 6px" }}>
            <span style={{ fontFamily:"'Barlow',sans-serif", fontSize:".75rem", color:C.muted }}>Semana:</span>
            {[0,1,2,3].map(wi=>(
              <button key={wi} className={`wbtn ${weekIdx===wi?"on":""}`} onClick={()=>setWeekIdx(wi)}>
                {wi===0?"Esta semana":`Sem -${wi}`}
              </button>
            ))}
          </div>
          <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".76rem", color:C.acc, padding:"0 6px 10px", fontWeight:600 }}>{weekLabel(weekIdx)}</div>
          <div style={{ overflowX:"auto" }}>
            <table style={{ borderCollapse:"collapse", minWidth:680 }}>
              <thead>
                <tr style={{ background:"#1a1a1a" }}>
                  <th style={th("left",120)}>PAN</th>
                  <th style={th("center",52)}>TIPO</th>
                  {DIAS.map(d=><th key={d} style={th("center",58)}>{d}</th>)}
                  <th style={th("center",60)}>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                {PANES.map((pan,pi)=>
                  ["pedido","entregado"].map((tipo,ti)=>{
                    const total = tipo==="entregado"?weekTotal(weeks[weekIdx],pan):null;
                    return (
                      <tr key={`${pan}${tipo}`} className="rh" style={{ background:ti===0?(pi%2===0?C.b1:C.b2):(pi%2===0?"#161616":"#131313"), borderBottom:ti===1?`1px solid ${C.border}`:"none" }}>
                        <td style={{ padding:"7px 10px", fontFamily:"'Barlow',sans-serif", fontWeight:ti===0?700:400, fontSize:".83rem", color:ti===0?C.txt:C.muted, borderRight:`1px solid ${C.border}` }}>
                          {ti===0?pan:""}
                        </td>
                        <td style={{ padding:"7px 4px", textAlign:"center", fontFamily:"'Barlow',sans-serif", fontSize:".68rem", color:tipo==="pedido"?"#666":C.acc, fontWeight:700, letterSpacing:1 }}>
                          {tipo==="pedido"?"PED":"ENT"}
                        </td>
                        {DIAS.map(dia=>{
                          const val = weeks[weekIdx]?.[pan]?.[dia]?.[tipo]??"";
                          const key = `w${weekIdx}${pan}${dia}${tipo}`;
                          return (
                            <td key={dia} style={{ textAlign:"center", padding:"5px 2px" }} onDoubleClick={()=>startEdit(key,val)}>
                              {editCell===key?(
                                <input className="ei" autoFocus value={editVal}
                                  onChange={e=>setEditVal(e.target.value)}
                                  onBlur={()=>commitWeek(pan,dia,tipo)}
                                  onKeyDown={e=>e.key==="Enter"&&commitWeek(pan,dia,tipo)} />
                              ):(
                                <span style={{ cursor:canEdit?"pointer":"default", fontFamily:"'Barlow',sans-serif", fontWeight:600, fontSize:".88rem", color:!val||val===0?C.dim:tipo==="entregado"?C.acc:"#aaa" }}>
                                  {!val||val===0?"·":val}
                                </span>
                              )}
                            </td>
                          );
                        })}
                        <td style={{ textAlign:"center", fontFamily:"'Barlow',sans-serif", fontWeight:700, fontSize:".9rem", color:total?C.acc:C.dim, borderLeft:`1px solid ${C.border}` }}>
                          {total!==null?(total||"·"):""}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <p style={{ textAlign:"center", fontFamily:"'Barlow',sans-serif", fontSize:".7rem", color:C.dim, padding:"10px 0" }}>
            {canEdit?"Doble click para editar · PED = pedido · ENT = entregado":"Solo lectura"}
          </p>
        </div>
      )}

      {/* ═══ RESUMEN ═══ */}
      {tab==="resumen" && (
        <div style={{ maxWidth:700, margin:"0 auto", padding:"16px 12px" }}>
          <div style={{ marginBottom:16 }}>
            <div style={{ fontSize:"1.6rem", letterSpacing:3, color:C.acc, marginBottom:4 }}>RESUMEN 4 SEMANAS</div>
            <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:".8rem", color:C.muted }}>Basado en lo entregado. El promedio te dice cuanto pedir.</div>
          </div>
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", minWidth:500 }}>
              <thead>
                <tr style={{ background:"#1a1a1a" }}>
                  <th style={th("left",130)}>PAN</th>
                  {[0,1,2,3].map(wi=>(
                    <th key={wi} style={th("center",80)}>
                      <div>{wi===0?"ESTA SEM":`SEM -${wi}`}</div>
                      <div style={{ fontSize:".58rem", color:C.muted, fontFamily:"'Barlow',sans-serif", fontWeight:400, marginTop:1 }}>{weekLabel(wi).split("-")[0].trim()}</div>
                    </th>
                  ))}
                  <th style={{ ...th("center",90), background:"#1a1500", color:C.acc }}>PEDIR</th>
                </tr>
              </thead>
              <tbody>
                {promedios.map(({pan,totals,avg},i)=>(
                  <tr key={pan} className="rh" style={{ background:i%2===0?C.b1:C.b2, borderBottom:`1px solid #1e1e1e` }}>
                    <td style={{ padding:"12px 12px", fontFamily:"'Barlow',sans-serif", fontWeight:700, fontSize:".88rem" }}>{pan}</td>
                    {totals.map((t,wi)=>(
                      <td key={wi} style={{ textAlign:"center", fontFamily:"'Barlow',sans-serif", fontWeight:600, color:t===0?C.dim:"#aaa", padding:"12px 6px" }}>{t||"-"}</td>
                    ))}
                    <td style={{ textAlign:"center", background:avg>0?"rgba(245,197,24,.07)":"transparent", borderLeft:`2px solid ${C.acc}` }}>
                      <div style={{ color:C.acc, fontFamily:"'Bebas Neue',sans-serif", fontSize:"1.4rem", letterSpacing:2 }}>{avg||"-"}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ═══ FOTO ═══ */}
      {tab==="foto" && canEdit && (
        <div style={{ maxWidth:440, margin:"40px auto", padding:"0 20px", textAlign:"center" }}>
          <div style={{ border:`2px dashed ${C.acc}`, borderRadius:12, padding:"40px 24px", cursor:"pointer" }} onClick={()=>fileRef.current?.click()}>
            {aiLoading?(<><div style={{ fontSize:"3rem" }}>🔍</div><p style={{ fontFamily:"'Barlow',sans-serif", color:C.acc, marginTop:12 }}>Analizando...</p></>):(
              <><div style={{ fontSize:"3.5rem" }}>📸</div>
              <div style={{ fontSize:"1.6rem", letterSpacing:3, color:C.acc, marginTop:12 }}>SUBIR FOTO</div>
              <p style={{ fontFamily:"'Barlow',sans-serif", color:C.muted, fontSize:".86rem", marginTop:8 }}>Saca foto a la planilla y Claude actualiza el stock solo.</p></>
            )}
            <input ref={fileRef} type="file" accept="image/*" style={{ display:"none" }} onChange={handleFoto} />
          </div>
          {aiMsg&&(
            <div style={{ marginTop:16, padding:"12px", background:aiMsg.startsWith("ok")?"#0d2e0d":"#2e0d0d", borderRadius:8, color:aiMsg.startsWith("ok")?"#4ade80":"#f87171", fontFamily:"'Barlow',sans-serif", fontWeight:600 }}>
              {aiMsg.startsWith("ok")?"✓":"❌"} {aiMsg.slice(3)}
              {aiMsg.startsWith("ok")&&(<button onClick={()=>setTab("stock")} style={{ display:"block", margin:"10px auto 0", background:C.acc, color:"#111", border:"none", borderRadius:6, padding:"8px 20px", fontFamily:"'Bebas Neue',sans-serif", fontSize:"1.1rem", letterSpacing:2, cursor:"pointer" }}>VER STOCK</button>)}
            </div>
          )}
        </div>
      )}

      {/* BOTTOM BAR */}
      <div className="np" style={{ position:"fixed", bottom:0, left:0, right:0, background:C.hd, borderTop:`2px solid ${C.border}`, padding:"10px 16px", display:"flex", gap:8, justifyContent:"center" }}>
        {canEdit&&<Btn onClick={downloadXLSX} icon="📊" label="EXCEL" color="#0d3a1a" />}
        <Btn onClick={()=>window.print()} icon="🖨️" label="IMPRIMIR" color="#0d1a3a" />
        {isAdmin&&<Btn onClick={()=>{const ok=window.confirm("Resetear stock diario?");if(ok)persist({stock:DEFAULT_STOCK_PANES,stockUpdated:new Date().toISOString()});}} icon="🔄" label="RESET" color="#3a0d0d" />}
      </div>
    </div>
  );
}

function Btn({onClick,icon,label,color}) {
  return (
    <button onClick={onClick} style={{ background:color, border:"none", borderRadius:7, padding:"9px 14px", color:"#fff", fontFamily:"'Bebas Neue',sans-serif", fontSize:".9rem", letterSpacing:2, cursor:"pointer", display:"flex", alignItems:"center", gap:5, flex:1, justifyContent:"center", maxWidth:160 }}>
      {icon} {label}
    </button>
  );
}
